// JINSU site content — all copy in Finnish, based on jinsu.fi (source of truth).
// Prices include VAT; shipping is added at checkout.

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/jinsu.fi", label: "@jinsu.fi" },
  { name: "Facebook", url: "https://www.facebook.com/share/19cUzbP4Hw/", label: "JINSU" },
  { name: "TikTok", url: "https://www.tiktok.com/@jinsu.fi", label: "@jinsu.fi" },
];

export const BRAND = {
  name: "JINSU",
  tagline: "JINSU – puhtaampaa vettä ihollesi ja hiuksillesi.",
  company: "M Beauties Oy",
  businessId: "3472510-6",
  email: "jinsu.finland@gmail.com",
};

export const DELIVERY = {
  processing: "Tilaukset käsitellään 1–3 arkipäivän kuluessa tilauksesta.",
  time: "Toimitusaika on yleensä 2–5 arkipäivää tilauksen lähettämisestä.",
  method: "Tilaukset toimitetaan Postin pakettipalveluiden kautta lähimpään noutopisteeseen tai pakettiautomaattiin.",
  area: "Toimitamme tällä hetkellä Suomeen.",
  costs: "Toimituskulut määräytyvät tilauksen mukaan ja esitetään kassalla ennen maksua.",
};

const VITAMIN_INGREDIENTS = [
  {
    name: "Vitamiini C",
    note: "korkea pitoisuus",
    points: [
      "Antioksidanttinen vaikutus tukee ihon hyvinvointia",
      "Auttaa vähentämään ihon kuivuutta ja sameutta",
    ],
  },
  {
    name: "Trehaloosi",
    note: "kosteudensitoja",
    points: [
      "Auttaa säilyttämään ihon ja hiusten luonnollisen rakenteen",
      "Parantaa kosteudensitomiskykyä",
      "Tukee ihon kimmoisuutta",
    ],
  },
  {
    name: "Glyseriini",
    note: "syväkosteutus",
    points: [
      "Syväkosteuttaa ihoa",
      "Vähentää kiristävää ja kuivaa tunnetta suihkun jälkeen",
    ],
  },
  {
    name: "Maitojauhe",
    note: "pehmittävä",
    points: [
      "Tukee ihon luonnollista tasapainoa",
      "Auttaa ylläpitämään ihon pehmeyttä",
    ],
  },
  {
    name: "Teepuu-uute",
    note: "rauhoittava",
    points: [
      "Rauhoittaa herkkää ja ärtynyttä ihoa",
      "Tukee ongelmaihon hoitoa",
    ],
  },
  {
    name: "Sedimenttisuodatin",
    note: "mekaaninen suodatus",
    points: ["Poistaa ruostetta, sakkaa ja muita mekaanisia epäpuhtauksia vedestä"],
  },
];

const VITAMIN_DESCRIPTION = [
  "Puhdasta vettä iholle ja hiuksille – joka päivä.",
  "Vitamiini C -suihkusuodatin on korkealaatuinen ja innovatiivinen ratkaisu suihkuveden laadun parantamiseen. Suodatin tukee ihon luonnollista tasapainoa ja auttaa hiuksia säilyttämään kosteuden, kiillon ja elinvoiman.",
  "Suodatin sisältää mietoja aromaterapeuttisia tuoksuja, jotka tekevät suihkuhetkestä rentouttavan ja miellyttävän. Aromaterapia tukee stressin lievittymistä ja lisää päivittäisen pesuhetken hyvinvointivaikutusta.",
];

const VITAMIN_SPECS = [
  { label: "Riittoisuus", value: "n. 7 200 litraa (n. 30 päivää / 4 hengen talous)" },
  { label: "Säilyvyys", value: "3 vuotta valmistuspäivästä" },
  { label: "Käyttölämpötila", value: "4–50 °C" },
  { label: "Yhteensopivuus", value: "Sopii kaikkiin Suomessa käytössä oleviin suihkupäihin ja hanoihin" },
  { label: "Asennus", value: "DIY-asennus – ei vaadi työkaluja" },
  { label: "Testaus", value: "Ihoallergia- ja ärsytystestit, kloorijäämätestit, haitallisten aineiden testaus" },
];

const VITAMIN_BENEFITS = [
  "Poistaa ruostetta, sakkaa ja muut mekaaniset epäpuhtaudet",
  "Vitamiini C tukee ihon hyvinvointia",
  "Trehaloosi ja glyseriini kosteuttavat ihoa ja hiuksia",
  "Mieto aromaterapeuttinen tuoksu tekee suihkusta rentouttavan",
  "Testattu ja turvallinen – täyttää turvallisuusvaatimukset",
];

const TARGET_GROUPS = [
  "Kuivasta tai herkästä ihosta kärsiville",
  "Hiusten kuivumista, sameutta tai haurastumista kokeville",
  "Lapsiperheille ja herkälle iholle",
  "Kaikille, jotka haluavat parantaa suihkuveden laatua",
];

const PERUS_SPECS_SHORT = [
  { label: "Poistaa", value: "Ruosteen ja metallihiukkaset, kloorin, hienon pölyn ja sedimentin" },
  { label: "Käyttöikä / suodatin", value: "n. 30–60 päivää (veden laadusta ja käytöstä riippuen)" },
  { label: "Yhteensopivuus", value: "Sopii kaikkiin Suomessa käytössä oleviin hanoihin ja suihkuihin" },
  { label: "Asennus", value: "Nopea asennus ilman työkaluja" },
  { label: "Runko", value: "Kierrätettävä PP-muovi (polypropeeni)" },
];

const BUNDLES = [
  {
    slug: "jinsu-perussuodatin-2kpl",
    name: "Jinsu Suihkusuodatin 2 kpl",
    price: 33.83,
    priceLabel: "33,83 €",
    compareAtLabel: "Norm. 39,80 €",
    saveLabel: "Säästät 5,97 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/clean-2.jpg",
    images: ["/images/clean-2.jpg"],
    short: "Kaksi suihkusuodatinta pakettihintaan – varasuodatin aina valmiina.",
    contents: ["2 × Jinsu Suodatin"],
    benefits: [
      "2 × Jinsu Suodatin",
      "Poistaa ruosteen, kloorin ja hienojakoiset epäpuhtaudet",
      "Varasuodatin valmiina vaihtoon – riittoisuus yhteensä n. 60–120 päivää",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Kaksi Jinsu Suihkusuodatinta edulliseen pakettihintaan. Suihkusuodatin poistaa suihku- ja hanavedestä ruosteen, kloorin ja hienojakoiset epäpuhtaudet juuri ennen käyttöä.",
      "Yhden suodattimen käyttöikä on noin 30–60 päivää veden laadusta ja käytöstä riippuen, joten kaksoispaketilla puhdasta vettä riittää jopa neljäksi kuukaudeksi.",
    ],
    specs: PERUS_SPECS_SHORT,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-perussuodatin-3kpl",
    name: "Jinsu Suihkusuodatin 3 kpl",
    price: 50.75,
    priceLabel: "50,75 €",
    compareAtLabel: "Norm. 59,70 €",
    saveLabel: "Säästät 8,95 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/clean-3.jpg",
    images: ["/images/clean-3.jpg"],
    short: "Kolme suihkusuodatinta pakettihintaan – puhdasta vettä puoleksi vuodeksi.",
    contents: ["3 × Jinsu Suodatin"],
    benefits: [
      "3 × Jinsu Suodatin",
      "Poistaa ruosteen, kloorin ja hienojakoiset epäpuhtaudet",
      "Riittoisuus yhteensä n. 90–180 päivää",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Kolme Jinsu Suihkusuodatinta edulliseen pakettihintaan. Suihkusuodatin poistaa suihku- ja hanavedestä ruosteen, kloorin ja hienojakoiset epäpuhtaudet juuri ennen käyttöä.",
      "Yhden suodattimen käyttöikä on noin 30–60 päivää veden laadusta ja käytöstä riippuen, joten kolmipaketilla puhdasta vettä riittää jopa puoleksi vuodeksi. Läpinäkyvä runko näyttää, milloin suodatin on vaihdettava.",
    ],
    specs: PERUS_SPECS_SHORT,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-start-paketti",
    name: "Jinsu Start-paketti",
    price: 38.08,
    priceLabel: "38,08 €",
    compareAtLabel: "Norm. 44,80 €",
    saveLabel: "Säästät 6,72 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/clean-2.jpg",
    images: ["/images/clean-2.jpg"],
    short: "Suihkusuodatin ja vitamiinisuodatin samassa paketissa – helppo tapa aloittaa.",
    contents: ["1 × Jinsu Suodatin", "1 × Jinsu Vitamiinisuodatin (Jasmin tai Mandariini)"],
    benefits: [
      "1 × Jinsu Suodatin – poistaa ruosteen, kloorin ja epäpuhtaudet",
      "1 × Vitamiinisuodatin – vitamiini C ja ihonhoitoainesosat, mieto tuoksu",
      "Täydellinen tapa tutustua molempiin suodattimiin",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Start-paketissa saat molemmat JINSU-suodattimet kerralla: suihkusuodattimen, joka poistaa ruosteen, kloorin ja hienojakoiset epäpuhtaudet, sekä vitamiinisuodattimen, joka lisää veteen ihonhoitoainesosia ja miedon aromaterapeuttisen tuoksun.",
      "Mainitse tuoksutoiveesi (Jasmin tai Mandariini) kassalla tilauksen lisätiedoissa.",
    ],
    specs: PERUS_SPECS_SHORT,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-complete-paketti",
    name: "Jinsu Complete-paketti",
    price: 55.0,
    priceLabel: "55,00 €",
    compareAtLabel: "Norm. 64,70 €",
    saveLabel: "Säästät 9,70 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/clean-2.jpg",
    images: ["/images/clean-2.jpg", "/images/suihkupaa.png"],
    short: "Täydellinen setti: suihku- ja vitamiinisuodatin sekä suihkupää mukana.",
    contents: [
      "1 × Jinsu Suodatin",
      "1 × Jinsu Vitamiinisuodatin (Jasmin tai Mandariini)",
      "1 × suihkupää",
    ],
    benefits: [
      "1 × Jinsu Suodatin – poistaa ruosteen, kloorin ja epäpuhtaudet",
      "1 × Vitamiinisuodatin – vitamiini C ja ihonhoitoainesosat, mieto tuoksu",
      "1 × suihkupää mukana – kaikki tarvittava kerralla",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Complete-paketti sisältää kaiken tarvittavan puhtaampaan suihkuveteen: suihkusuodattimen, vitamiinisuodattimen sekä suihkupään. Asennus käden käänteessä ilman työkaluja.",
      "Mainitse tuoksutoiveesi (Jasmin tai Mandariini) kassalla tilauksen lisätiedoissa.",
    ],
    specs: PERUS_SPECS_SHORT,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-vitamiinisuodatin-2kpl",
    name: "Jinsu Vitamiinisuodatin 2 kpl",
    price: 42.33,
    priceLabel: "42,33 €",
    compareAtLabel: "Norm. 49,80 €",
    saveLabel: "Säästät 7,47 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "jasmin",
    image: "/images/clean-2.jpg",
    images: ["/images/clean-2.jpg"],
    short: "Kaksi vitamiinisuodatinta pakettihintaan – valitse tuoksuksi Jasmin tai Mandariini.",
    contents: ["2 × Jinsu Vitamiinisuodatin (Jasmin tai Mandariini)"],
    benefits: [
      "2 × Jinsu Vitamiinisuodatin",
      "Vitamiini C, trehaloosi, glyseriini, maitojauhe ja teepuu-uute",
      "Riittoisuus yhteensä n. 14 400 litraa (n. 60 pv / 4 h talous)",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Kaksi Jinsu Vitamiinisuodatinta edulliseen pakettihintaan. Vitamiinisuodatin poistaa vedestä ruostetta, sakkaa ja mekaaniset epäpuhtaudet ja lisää veteen ihonhoitoainesosia sekä miedon aromaterapeuttisen tuoksun.",
      "Yhden vitamiinisuodattimen riittoisuus on noin 7 200 litraa eli noin 30 päivää nelihenkisessä taloudessa. Mainitse tuoksutoiveesi (Jasmin tai Mandariini) kassalla tilauksen lisätiedoissa.",
    ],
    specs: VITAMIN_SPECS,
    ingredients: VITAMIN_INGREDIENTS,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-vitamiinisuodatin-3kpl",
    name: "Jinsu Vitamiinisuodatin 3 kpl",
    price: 63.5,
    priceLabel: "63,50 €",
    compareAtLabel: "Norm. 74,70 €",
    saveLabel: "Säästät 11,20 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "jasmin",
    image: "/images/clean-3.jpg",
    images: ["/images/clean-3.jpg"],
    short: "Kolme vitamiinisuodatinta pakettihintaan – valitse tuoksuksi Jasmin tai Mandariini.",
    contents: ["3 × Jinsu Vitamiinisuodatin (Jasmin tai Mandariini)"],
    benefits: [
      "3 × Jinsu Vitamiinisuodatin",
      "Vitamiini C, trehaloosi, glyseriini, maitojauhe ja teepuu-uute",
      "Riittoisuus yhteensä n. 21 600 litraa (n. 90 pv / 4 h talous)",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Kolme Jinsu Vitamiinisuodatinta edulliseen pakettihintaan. Vitamiinisuodatin poistaa vedestä ruostetta, sakkaa ja mekaaniset epäpuhtaudet ja lisää veteen ihonhoitoainesosia sekä miedon aromaterapeuttisen tuoksun.",
      "Yhden vitamiinisuodattimen riittoisuus on noin 7 200 litraa eli noin 30 päivää nelihenkisessä taloudessa, joten kolmipaketti riittää jopa kolmeksi kuukaudeksi. Mainitse tuoksutoiveesi (Jasmin tai Mandariini) kassalla tilauksen lisätiedoissa.",
    ],
    specs: VITAMIN_SPECS,
    ingredients: VITAMIN_INGREDIENTS,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-family-paketti",
    name: "Jinsu Family-paketti",
    price: 76.16,
    priceLabel: "76,16 €",
    compareAtLabel: "Norm. 89,60 €",
    saveLabel: "Säästät 13,44 €",
    savePercent: 15,
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/clean-4.jpg",
    images: ["/images/clean-4.jpg"],
    short: "Koko perheen paketti: kaksi suihku- ja kaksi vitamiinisuodatinta.",
    contents: ["2 × Jinsu Suihkusuodatin", "2 × Jinsu Vitamiinisuodatin (Jasmin tai Mandariini)"],
    benefits: [
      "2 × Jinsu Suihkusuodatin – poistaa ruosteen, kloorin ja epäpuhtaudet",
      "2 × Vitamiinisuodatin – vitamiini C ja ihonhoitoainesosat, mieto tuoksu",
      "Riittää koko perheelle tai useampaan kylpyhuoneeseen",
      "Pakettihinta: säästät 15 %",
    ],
    description: [
      "Family-paketti on koko perheen valinta: kaksi suihkusuodatinta ja kaksi vitamiinisuodatinta samassa paketissa. Sopii myös koteihin, joissa on useampi suihku tai hana.",
      "Mainitse tuoksutoiveesi (Jasmin tai Mandariini) kassalla tilauksen lisätiedoissa.",
    ],
    specs: PERUS_SPECS_SHORT,
    targetGroups: TARGET_GROUPS,
  },
];

export const PRODUCTS = [
  {
    slug: "jinsu-suodatin",
    name: "Jinsu Suodatin",
    price: 19.9,
    priceLabel: "19,90 €",
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/suodatin-main.jpg",
    images: ["/images/suodatin-main.jpg", "/images/suodatin-alt.jpg"],
    short: "Poistaa ruosteen, kloorin ja hienojakoiset epäpuhtaudet suihku- ja hanavedestä.",
    benefits: [
      "Poistaa ruosteen ja metallihiukkaset",
      "Poistaa kloorin",
      "Poistaa hienon pölyn ja sedimentin",
      "Auttaa ehkäisemään ihon kuivumista",
      "Tukee pehmeämpää ihoa ja sileämpiä hiuksia",
    ],
    description: [
      "JINSU-suihkusuodatin on tehokas ja helppokäyttöinen ratkaisu ruosteen, kloorin ja hienojakoisten epäpuhtauksien poistamiseen suihku- ja hanavedestä. Se on suunniteltu parantamaan veden laatua sekä suojaamaan ihoa ja hiuksia päivittäisessä käytössä.",
      "Monissa kodeissa vesi kulkee vanhojen putkien läpi, jolloin veteen voi päätyä ruostetta ja muita näkymättömiä hiukkasia. JINSU-suodatin puhdistaa veden juuri ennen käyttöä – siellä missä sillä on eniten merkitystä.",
      "JINSU hyödyntää korkealaatuista suodatinrakennetta. Tuloksena on kirkkaampi, puhtaampi ja miellyttävämpi vesi.",
    ],
    materials: [
      "Runko: kestävä ja elintarvikekäyttöön soveltuva PP-muovi (polypropeeni)",
      "Kierrätettävää muovia",
      "Tiivisteet: laadukkaat silikoniset O-renkaat vuotojen estämiseksi",
      "Suodatinosa: tiheä mikrokuitupohjainen suodatinmateriaali, joka sitoo ruostetta ja epäpuhtauksia tehokkaasti",
      "Materiaalit ovat RoHS-yhteensopivia, eivät sisällä haitallisia aineita ja soveltuvat päivittäiseen kotikäyttöön",
    ],
    specs: [
      { label: "Poistaa", value: "Ruosteen ja metallihiukkaset, kloorin, hienon pölyn ja sedimentin" },
      { label: "Runko", value: "Elintarvikekäyttöön soveltuva, kierrätettävä PP-muovi" },
      { label: "Käyttöikä", value: "n. 30–60 päivää (veden laadusta ja käytöstä riippuen)" },
      { label: "Vaihtotarve", value: "Läpinäkyvä runko näyttää, milloin suodatin on vaihdettava" },
      { label: "Yhteensopivuus", value: "Sopii kaikkiin Suomessa käytössä oleviin hanoihin ja suihkuihin" },
      { label: "Asennus", value: "Nopea asennus ilman työkaluja" },
    ],
    ingredients: null,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-suihkupaa",
    name: "Jinsu Suihkupää",
    price: 19.9,
    priceLabel: "19,90 €",
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "water",
    image: "/images/suihkupaa.png",
    images: ["/images/suihkupaa.png"],
    short: "Helppoasenteinen suihkupää – täydellinen pari Jinsu-suodattimille.",
    benefits: [
      "Nopea asennus ilman työkaluja",
      "Sopii saumattomasti yhteen Jinsu Suodattimen ja Vitamiinisuodattimen kanssa",
      "Tasainen ja miellyttävä vesisuihku",
      "Kestävä ja helppohoitoinen",
    ],
    description: [
      "Jinsu Suihkupää on helppoasenteinen ja kestävä suihkupää, joka sopii saumattomasti yhteen JINSU-suodattimien kanssa. Se kiinnittyy tavalliseen suihkuletkuun ilman työkaluja – käyttövalmis muutamassa minuutissa.",
      "Suihkupää tarjoaa tasaisen ja miellyttävän vesisuihkun, ja se on myös Complete-paketin mukana tuleva suihkupää erikseen ostettuna – sopii esimerkiksi toiseen kylpyhuoneeseen tai varaosaksi.",
    ],
    materials: null,
    specs: [
      { label: "Asennus", value: "Nopea asennus ilman työkaluja – kiinnittyy tavalliseen suihkuletkuun" },
      { label: "Yhteensopivuus", value: "Sopii kaikkiin Suomessa käytössä oleviin suihkuletkuihin ja JINSU-suodattimiin" },
      { label: "Hoito", value: "Huuhtele säännöllisesti puhtaaksi – ei vaihdettavia osia" },
    ],
    ingredients: null,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-vitamiinisuodatin-jasmin",
    name: "Jinsu Vitamiinisuodatin Jasmin",
    price: 24.9,
    priceLabel: "24,90 €",
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "jasmin",
    scent: "Mieto jasmiinin tuoksu",
    image: "/images/jasmin-main.jpg",
    images: ["/images/jasmin-main.jpg"],
    short: "Vitamiini C -suihkusuodatin miedolla jasmiinin tuoksulla – puhdasta vettä iholle ja hiuksille.",
    benefits: VITAMIN_BENEFITS,
    description: VITAMIN_DESCRIPTION,
    materials: null,
    specs: VITAMIN_SPECS,
    ingredients: VITAMIN_INGREDIENTS,
    targetGroups: TARGET_GROUPS,
  },
  {
    slug: "jinsu-vitamiinisuodatin-mandariini",
    name: "Jinsu Vitamiinisuodatin Mandariini",
    price: 24.9,
    priceLabel: "24,90 €",
    inStock: true,
    deliveryTime: "3 päivä(ä)",
    accent: "mandariini",
    scent: "Mieto mandariinin tuoksu",
    image: "/images/mandariini-main.jpg",
    images: ["/images/mandariini-main.jpg"],
    short: "Vitamiini C -suihkusuodatin miedolla mandariinin tuoksulla – puhdasta vettä iholle ja hiuksille.",
    benefits: VITAMIN_BENEFITS,
    description: VITAMIN_DESCRIPTION,
    materials: null,
    specs: VITAMIN_SPECS,
    ingredients: VITAMIN_INGREDIENTS,
    targetGroups: TARGET_GROUPS,
  },
  ...BUNDLES,
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const INGREDIENTS = VITAMIN_INGREDIENTS;

export const COMPARISON = {
  columns: [
    { slug: "jinsu-suodatin", name: "Jinsu Suodatin" },
    { slug: "jinsu-vitamiinisuodatin-jasmin", name: "Vitamiinisuodatin Jasmin" },
    { slug: "jinsu-vitamiinisuodatin-mandariini", name: "Vitamiinisuodatin Mandariini" },
  ],
  rows: [
    { label: "Hinta", values: ["19,90 €", "24,90 €", "24,90 €"] },
    {
      label: "Poistaa vedestä",
      values: [
        "Ruoste, metallihiukkaset, kloori, hieno pöly ja sedimentti",
        "Ruoste, sakka ja muut mekaaniset epäpuhtaudet",
        "Ruoste, sakka ja muut mekaaniset epäpuhtaudet",
      ],
    },
    {
      label: "Ihonhoitoainesosat",
      values: [
        "–",
        "Vitamiini C, trehaloosi, glyseriini, maitojauhe, teepuu-uute",
        "Vitamiini C, trehaloosi, glyseriini, maitojauhe, teepuu-uute",
      ],
    },
    { label: "Tuoksu", values: ["Tuoksuton", "Mieto jasmiini", "Mieto mandariini"] },
    {
      label: "Riittoisyys / käyttöikä",
      values: ["n. 30–60 päivää", "n. 7 200 l (n. 30 pv / 4 h talous)", "n. 7 200 l (n. 30 pv / 4 h talous)"],
    },
    {
      label: "Asennus",
      values: [
        "Ilman työkaluja – sopii kaikkiin hanoihin ja suihkuihin Suomessa",
        "Ilman työkaluja – sopii kaikkiin suihkupäihin ja hanoihin Suomessa",
        "Ilman työkaluja – sopii kaikkiin suihkupäihin ja hanoihin Suomessa",
      ],
    },
    { label: "Käyttölämpötila", values: ["–", "4–50 °C", "4–50 °C"] },
  ],
};

export const FAQ_ITEMS = [
  {
    q: "Kuinka nopeasti saan tilaukseni?",
    a: "Tilaukset käsitellään 1–3 arkipäivän kuluessa tilauksesta. Toimitusaika on yleensä 2–5 arkipäivää tilauksen lähettämisestä. Mahdollisista viivästyksistä ilmoitetaan erikseen.",
  },
  {
    q: "Miten tilaus toimitetaan?",
    a: "Tilaukset toimitetaan Postin pakettipalveluiden kautta lähimpään noutopisteeseen tai pakettiautomaattiin. Toimitamme tällä hetkellä kaikkialle Suomeen.",
  },
  {
    q: "Kuinka usein suodatin kannattaa vaihtaa?",
    a: "Jinsu Suodatin suositeltu käyttöikä on noin 30–60 päivää veden laadusta ja käytöstä riippuen. Vitamiinisuodattimen riittoisuus on noin 7 200 litraa eli noin 30 päivää nelihenkisessä taloudessa. Läpinäkyvä runko helpottaa vaihtotarpeen seuraamista.",
  },
  {
    q: "Sopiiko suodatin minun suihkuuni tai hanaani?",
    a: "Kyllä sopii. JINSU-suodattimet sopivat kaikkiin Suomessa käytössä oleviin hanoihin ja suihkuihin, eikä asennus vaadi työkaluja.",
  },
  {
    q: "Tarvitsenko asennukseen työkaluja?",
    a: "Et. Suodatin asennetaan käsin ilman työkaluja – kierrät suodattimen suihkuletkun ja hanan väliin, ja se on valmis käytettäväksi.",
  },
  {
    q: "Mikä ero on Jinsu Suodattimella ja Vitamiinisuodattimella?",
    a: "Jinsu Suodatin poistaa vedestä ruosteen, kloorin ja hienojakoiset epäpuhtaudet. Vitamiinisuodatin poistaa mekaaniset epäpuhtaudet ja sisältää lisäksi ihonhoitoainesosia – vitamiini C:tä, trehaloosia, glyseriiniä, maitojauhetta ja teepuu-uutetta – sekä miedon aromaterapeuttisen tuoksun.",
  },
  {
    q: "Mikä ero on Jasmin- ja Mandariini-tuoksuilla?",
    a: "Jasmin on voimakkaampi ja mandariini miedompi vesi. Muuten suodattimet ovat sisällöltään samanlaisia: molemmissa on samat ihonhoitoainesosat – vitamiini C, trehaloosi, glyseriini, maitojauhe ja teepuu-uute – sekä sama sedimenttisuodatin, joka poistaa vedestä ruostetta, sakkaa ja mekaanisia epäpuhtauksia. Riittoisuuskin on sama: noin 7 200 litraa eli noin 30 päivää nelihenkisessä taloudessa. Jos pidät selkeämmästä, kukkaisemmasta tuoksusta, valitse Jasmin. Jos haluat kevyemmän ja huomaamattomamman tuoksun, Mandariini on sinun valintasi.",
  },
  {
    q: "Kuinka käytetty suodatin kierrätetään?",
    a: "JINSU-suodattimet on valmistettu polypropeenista (PP), joka on kierrätettävää muovia. Kun suodattimen käyttöikä on lopussa, laita se muovinkeräykseen – materiaali saa näin uuden elämän. Runko on kestävä, joten vaihdat vain sisällä olevan suodattimen, mikä vähentää jätettä.",
  },
  {
    q: "Miten peruutusoikeus ja palautukset toimivat?",
    a: "Sinulla on Suomen kuluttajansuojalain mukainen 14 päivän peruutusoikeus tilauksen vastaanottamisesta. Palautettavan tuotteen tulee olla käyttämätön ja alkuperäisessä kunnossa. Asiakas vastaa palautuskustannuksista, ellei toisin ole sovittu.",
  },
  {
    q: "Miten voin olla yhteydessä?",
    a: "Voit ottaa meihin yhteyttä yhteystiedot-sivun lomakkeella tai sähköpostitse osoitteeseen jinsu.finland@gmail.com.",
  },
];

export const LEGAL_PAGES = {
  "maksu-ja-toimitus": {
    title: "Maksu ja toimitus",
    meta: "Toimitus- ja maksutiedot – JINSU-verkkokauppa toimittaa tilaukset Postin kautta kaikkialle Suomeen.",
    sections: [
      {
        heading: "Toimitustavat",
        paragraphs: [
          "Tarjoamme luotettavan toimituksen kaikkialle Suomeen.",
          "Tilaukset toimitetaan Postin pakettipalveluiden kautta lähimpään noutopisteeseen tai pakettiautomaattiin.",
        ],
      },
      {
        heading: "Toimitusaika",
        paragraphs: [
          "Tilaukset käsitellään 1–3 arkipäivän kuluessa tilauksesta.",
          "Toimitusaika on yleensä 2–5 arkipäivää tilauksen lähettämisestä.",
          "Mahdollisista viivästyksistä ilmoitetaan asiakkaalle erikseen.",
        ],
      },
      {
        heading: "Toimituskulut",
        paragraphs: ["Toimituskulut määräytyvät tilauksen mukaan ja esitetään kassalla ennen maksua."],
      },
      { heading: "Toimitusalue", paragraphs: ["Toimitamme tällä hetkellä Suomeen."] },
      {
        heading: "Noutamatta jäänyt paketti",
        paragraphs: ["Noutamatta jätetystä paketista veloitamme tilauksen täyden summan, sekä käsittely- ja palautuskulun."],
      },
      {
        heading: "Ongelmatilanteet toimituksessa",
        paragraphs: ["Mikäli tuote katoaa tai vaurioituu kuljetuksen aikana, olethan meihin yhteydessä mahdollisimman pian."],
      },
    ],
  },
  tietosuojakaytanto: {
    title: "Tietosuojakäytäntö",
    meta: "JINSU-verkkokaupan tietosuojaseloste – mitä tietoja keräämme ja mihin niitä käytetään.",
    sections: [
      {
        heading: "Rekisterinpitäjä",
        paragraphs: ["M Beauties Oy", "3472510-6", "jinsu.finland@gmail.com"],
      },
      {
        heading: "Mitä tietoja keräämme",
        paragraphs: [
          "Keräämme asiakkaista seuraavia tietoja:",
          "Nimi, osoite, sähköpostiosoite, puhelinnumero, maksu- ja tilaustiedot sekä IP-osoite ja sivuston käyttöön liittyvät tiedot.",
        ],
      },
      {
        heading: "Mihin tarkoitukseen tietoja käytetään",
        paragraphs: [
          "Henkilötietoja käytetään seuraaviin tarkoituksiin:",
          "Tilausten käsittelyyn ja toimittamiseen, asiakaspalveluun, maksujen käsittelyyn, verkkosivuston kehittämiseen ja analytiikkaan sekä markkinointiin (vain asiakkaan suostumuksella, jos käytössä).",
        ],
      },
      {
        heading: "Tietojen käsittelyn oikeusperuste",
        paragraphs: [
          "Henkilötietojen käsittely perustuu sopimuksen täytäntöönpanoon (tilaukset), lakisääteisiin velvoitteisiin sekä asiakkaan suostumukseen (esim. markkinointi).",
        ],
      },
      {
        heading: "Tietojen säilytysaika",
        paragraphs: [
          "Säilytämme henkilötietoja vain niin kauan kuin se on tarpeen: asiakassuhteen ajan sekä kirjanpitolain edellyttämän ajan (yleensä 6 vuotta).",
        ],
      },
    ],
  },
  evastekaytanto: {
    title: "Evästekäytäntö",
    meta: "JINSU-verkkokaupan evästekäytäntö – mitä evästeitä käytämme ja mihin.",
    sections: [
      {
        heading: "Mitä evästeet ovat?",
        paragraphs: [
          "Evästeet ovat pieniä tekstitiedostoja, jotka tallennetaan käyttäjän laitteelle verkkosivustoa käytettäessä. Evästeiden avulla verkkosivusto toimii oikein, turvallisesti ja tehokkaasti.",
        ],
      },
      {
        heading: "Mihin käytämme evästeitä?",
        paragraphs: [
          "Käytämme evästeitä seuraaviin tarkoituksiin: verkkosivuston toiminnallisuuden varmistamiseen, ostoskorin ja tilausten käsittelyyn, sivuston käytön analysointiin ja kehittämiseen sekä markkinointiin ja kohdennettuun mainontaan.",
        ],
      },
      {
        heading: "Evästetyypit",
        paragraphs: [
          "Välttämättömät evästeet ovat välttämättömiä verkkosivuston toiminnan kannalta (esim. ostoskori).",
          "Analytiikkaevästeiden avulla keräämme tietoa siitä, miten sivustoa käytetään (esim. kävijämäärät ja suosituimmat sivut).",
          "Markkinointievästeitä käytetään mainonnan kohdentamiseen ja markkinoinnin tehokkuuden mittaamiseen.",
        ],
      },
      {
        heading: "Evästeiden hallinta",
        paragraphs: ["Voit hallita ja muuttaa evästeasetuksia selaimesi asetuksista."],
      },
      {
        heading: "Kolmannen osapuolen evästeet",
        paragraphs: [
          "Sivustollamme voidaan käyttää kolmansien osapuolien palveluita, kuten analytiikka- tai maksupalveluita, jotka voivat asettaa evästeitä.",
        ],
      },
      {
        heading: "Tietosuoja",
        paragraphs: ["Evästeiden kautta kerättyjä tietoja käsitellään tietosuojaselosteemme mukaisesti."],
      },
      {
        heading: "Muutokset evästekäytäntöön",
        paragraphs: ["Pidätämme oikeuden päivittää tätä evästekäytäntöä tarvittaessa."],
      },
    ],
  },
  kayttoehdot: {
    title: "Käyttöehdot",
    meta: "JINSU-verkkokaupan käyttöehdot – tilaukset, hinnat, maksaminen, toimitus ja palautukset.",
    sections: [
      {
        heading: "Yleistä",
        paragraphs: [
          "Nämä käyttöehdot koskevat JINSU-verkkokauppaa ja sen kautta tehtäviä tilauksia.",
          "Tekemällä tilauksen asiakas hyväksyy nämä käyttöehdot.",
          "Myyjä: M Beauties Oy, 3472510-6, jinsu.finland@gmail.com",
          "Pidätämme oikeuden muuttaa näitä ehtoja ilman ennakkoilmoitusta.",
        ],
      },
      {
        heading: "Tuotteet ja hinnat",
        paragraphs: [
          "Kaikki hinnat on ilmoitettu euroissa (€) ja sisältävät arvonlisäveron 25,5 %.",
          "Pidätämme oikeuden hintojen ja toimituskulujen muutoksiin.",
        ],
      },
      {
        heading: "Tilaaminen",
        paragraphs: [
          "Tilaukset tehdään verkkokaupan kautta lisäämällä tuotteet ostoskoriin ja maksamalla kassalla.",
          "Asiakas vastaa antamiensa tietojen oikeellisuudesta.",
        ],
      },
      {
        heading: "Maksaminen",
        paragraphs: ["Maksu suoritetaan verkkokaupan kassalla tarjolla olevilla maksutavoilla."],
      },
      {
        heading: "Toimitus",
        paragraphs: [
          "Tilaukset toimitetaan Postin kautta noutopisteeseen tai pakettiautomaattiin.",
          "Toimitusaika on yleensä 2–5 arkipäivää.",
          "Tarkemmat toimitustiedot löytyvät Toimitustiedot-sivulta.",
        ],
      },
      {
        heading: "Peruutusoikeus ja palautukset",
        paragraphs: [
          "Kuluttajalla on Suomen kuluttajansuojalain mukainen 14 päivän peruutusoikeus tilauksen vastaanottamisesta.",
          "Palautettavan tuotteen tulee olla käyttämätön ja alkuperäisessä kunnossa.",
          "Asiakas vastaa palautuskustannuksista, ellei toisin ole ilmoitettu.",
        ],
      },
      {
        heading: "Virheelliset tuotteet",
        paragraphs: ["Mikäli tuote on viallinen tai virheellinen, asiakkaan tulee ottaa yhteyttä mahdollisimman pian."],
      },
      {
        heading: "Vastuunrajoitus",
        paragraphs: ["JINSU ei vastaa välillisistä vahingoista, jotka aiheutuvat tuotteen käytöstä tai toimituksen viivästymisestä."],
      },
      {
        heading: "Sovellettava laki",
        paragraphs: [
          "Näihin käyttöehtoihin sovelletaan Suomen lakia.",
          "Mahdolliset riitatilanteet pyritään ratkaisemaan ensisijaisesti neuvottelemalla.",
        ],
      },
      { heading: "Yhteystiedot", paragraphs: ["Sähköposti: jinsu.finland@gmail.com"] },
    ],
  },
  peruutusoikeus: {
    title: "Peruutusoikeus ja palautukset",
    meta: "Peruutusoikeus ja palautukset – 14 päivän peruutusoikeus Suomen kuluttajansuojalain mukaisesti.",
    sections: [
      {
        heading: "Peruutusoikeus",
        paragraphs: [
          "Kuluttajalla on Suomen kuluttajansuojalain mukainen oikeus peruuttaa tilaus 14 päivän kuluessa tavaran vastaanottamisesta ilman erityistä syytä.",
          "Peruutusajan päättymiseksi riittää, että ilmoitat peruutuksesta ennen määräajan umpeutumista.",
        ],
      },
      {
        heading: "Peruutuksen tekeminen",
        paragraphs: [
          "Peruutus tulee ilmoittaa selkeästi sähköpostitse.",
          "Yhteystiedot: jinsu.finland@gmail.com",
        ],
      },
      {
        heading: "Palautusehdot",
        paragraphs: [
          "Palautettavan tuotteen tulee olla käyttämätön, alkuperäisessä kunnossa ja alkuperäispakkauksessa.",
          "Pidätämme oikeuden vähentää palautettavasta summasta arvonalenemisen, mikäli tuotetta on käytetty muuten kuin sen luonteen, ominaisuuksien ja toimivuuden toteamiseksi.",
        ],
      },
      {
        heading: "Palautuskustannukset",
        paragraphs: ["Asiakas vastaa palautuskustannuksista, ellei toisin ole sovittu."],
      },
      {
        heading: "Maksun palautus",
        paragraphs: [
          "Palautamme maksun 14 päivän kuluessa peruutusilmoituksen vastaanottamisesta.",
          "Voimme kuitenkin pidättyä maksun palautuksesta, kunnes olemme vastaanottaneet palautetun tuotteen ja tuote on avaamaton, tai asiakas on osoittanut lähettäneensä tuotteen takaisin.",
          "Palautus suoritetaan samalla maksutavalla, jota asiakas käytti alkuperäisessä maksussa.",
        ],
      },
    ],
  },
};
